import { useState, useCallback } from 'react';
import { GetAllServices } from '../services/api/methods.ts';
import { Service } from '../services/api/types.ts';

export const useService = () => {
    const [service, setService] = useState<Service[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadServices = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const result = await GetAllServices();
            setService(result.Services);
        } catch (err: any) {
            setError('Ошибка при загрузке акций');
            console.error('Ошибка при загрузке акций', err);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        service,
        loading,
        error,
        loadServices,
        setService,
        setError
    };
};
